__turbopack_context__.v({
  "footer": "page-module__3qQxqq__footer",
  "page": "page-module__3qQxqq__page",
});
